import axios from 'axios';
import {
  PAYOUT_INITIATE_REQUEST,
  PAYOUT_INITIATE_SUCCESS,
  PAYOUT_INITIATE_FAIL,
  CHECK_PAYOUT_STATUS_REQUEST,
  CHECK_PAYOUT_STATUS_SUCCESS,
  CHECK_PAYOUT_STATUS_FAIL,
  PAYOUT_INITIATE_RESET, 
  serviceUrl,
  baseURL// Assuming you have a reset action type
} from './types';

// --- CONFIGURATION ---
const API_BASE_URL = `${baseURL}/api`; 
const getToken = () => localStorage.getItem('token');

/**
 * Action to initiate a payout request.
 */
export const initiatePayout = (payoutData) => async (dispatch) => {
  console.log('[ACTION] initiatePayout: Triggered.', { payload: payoutData });
  try {
    dispatch({ type: PAYOUT_INITIATE_REQUEST });
    console.log('[ACTION] initiatePayout: Dispatched PAYOUT_INITIATE_REQUEST.');
    
    const config = { 
      headers: { 
        'Content-Type': 'application/json', 
        Authorization: `Bearer ${getToken()}` 
      } 
    };
    const apiUrl = `${serviceUrl}/api/appointmentPayments/createpayouts`;
    
    console.log(`[ACTION] initiatePayout: Making POST request to ${apiUrl}.`);
    const { data } = await axios.post(apiUrl, payoutData, config);
    console.log('[ACTION] initiatePayout: API call successful.', { response: data });

    dispatch({ type: PAYOUT_INITIATE_SUCCESS, payload: data });
    console.log('[ACTION] initiatePayout: Dispatched PAYOUT_INITIATE_SUCCESS.');

  } catch (error) {
    const message = error.response?.data?.message || error.message;
    console.error('[ACTION] initiatePayout: API call failed.', { error: message });
    dispatch({ type: PAYOUT_INITIATE_FAIL, payload: message });
    console.log('[ACTION] initiatePayout: Dispatched PAYOUT_INITIATE_FAIL.');
  }
};

/**
 * Action to check the status of a specific payout.
 */
export const checkPayoutStatus = (payoutId) => async (dispatch) => {
  console.log(`[ACTION] checkPayoutStatus: Triggered for payout_id: ${payoutId}`);
  try {
    dispatch({ type: CHECK_PAYOUT_STATUS_REQUEST });
    console.log('[ACTION] checkPayoutStatus: Dispatched CHECK_PAYOUT_STATUS_REQUEST.');

    const config = { 
      headers: { 
        'Content-Type': 'application/json', 
        Authorization: `Bearer ${getToken()}` 
      } 
    };
    const apiUrl = `http://3.27.121.21:3331/api/hospitalpaymentspayout/getall`;
    const body = { payout_id: payoutId };

    console.log(`[ACTION] checkPayoutStatus: Making POST request to ${apiUrl}.`);
    const { data } = await axios.post(apiUrl, body, config);
    console.log(`[ACTION] checkPayoutStatus: API call for ${payoutId} successful.`, { response: data });

    dispatch({ type: CHECK_PAYOUT_STATUS_SUCCESS, payload: data });
    console.log('[ACTION] checkPayoutStatus: Dispatched CHECK_PAYOUT_STATUS_SUCCESS.');
    return data; // Return data for promise handling

  } catch (error) {
    const message = error.response?.data?.message || error.message;
    console.error(`[ACTION] checkPayoutStatus: API call failed for ${payoutId}.`, { error: message });
    dispatch({ type: CHECK_PAYOUT_STATUS_FAIL, payload: message });
    console.log('[ACTION] checkPayoutStatus: Dispatched CHECK_PAYOUT_STATUS_FAIL.');
    throw error; // Throw error for promise handling
  }
};